import $http from '../../axios';
import {MessageBox, Notification} from 'element-ui';
import moment from 'moment';

export async function fetchContactsWarehouses({commit, state}, seller_id) {
    if (seller_id) {
        let parameters = {params: state.params};

        parameters.params.seller_id = seller_id;

        await $http.get('/api/establecimientos-vendedor', parameters).then((response) => {
            commit('setContactsWarehouses', response.data.data);
        }).catch((error) => {
            console.log(error);
        });
    }
}

export async function fetchContacts({commit, state}, filter) {
    if (filter.length >= 3) {
        let parameters = {params: {filter: filter}};

        await $http.get('/api/filtrar-terceros', parameters).then((response) => {
            commit('setContacts', response.data.data);
        }).catch((error) => {
            console.log(error);
        });
    }
}


export async function fetchUsers({commit, state}, leadership_id = null) {

    if (!!leadership_id) {
        await $http.get('/api/jefaturas/' + leadership_id).then((response) => {
            commit('setUsers', response.data.data);
        });
    } else {
        let user = JSON.parse(localStorage.user);

        let parameters = {
            params: {
                paginate: false,
                subscriber_id: user.subscriber_id
            }
        };

        await $http.get('/api/usuarios', parameters).then((response) => {
            commit('setTotalUsers', response.data.data);
        });
    }
}

export async function fetchLeaderships({commit}) {
    await $http.get('/api/jefaturas', {params: {paginate: false}})
        .then((response) => {
            commit('setLeaderships', response.data.data);
        });
}

export async function fetchEvents({commit, state}) {

    let parameters = state.parameters;

    parameters.start_date = moment(parameters.start_date).format('YYYY-MM-DD');
    parameters.end_date = moment(parameters.end_date).format('YYYY-MM-DD');

    let params = {
        params: parameters
    };

    await $http.get('/api/eventos', params)
        .then((response) => {
            commit('setEvents', response.data.data);

            let contacts = [];

            response.data.data.map(e => {
                if (e.contact) {
                    contacts.push(e.contact);
                }
            });

            commit('setContacts', contacts);

        }).catch((error) => {
            console.log(error);
        });
}

export async function fetchHolidays({commit}) {
    await $http.get('/api/eventos/festivos')
        .then((response) => {
            commit('setHolidays', response.data.data);
        }).catch((error) => {
            console.log(error);
        });
}

export async function fetchEvent({commit, state}, event_id) {
    await $http.get('/api/eventos/' + event_id)
        .then((response) => {
            commit('setEvent', response.data.data);
        }).catch((error) => {
            console.log(error);
        });
}

export async function fetchLastEvent({commit, state}) {

    const parameters = {
        params: {
            start_date: state.event.start_date,
            start_time: state.event.start_time,
            user_id: state.event.user_id
        }
    };

    await $http.get('/api/eventos/ultimo', parameters)
        .then((response) => {
            commit('updateDistance', response.data.data);
        }).catch((error) => {
            console.log(error);
        });
}


export async function fetchEventsDay({commit, state}, contact_id) {

    let parameters = {
        params: {
            start_date: moment().format('YYYY-MM-DD'),
            end_date: moment().format('YYYY-MM-DD'),
            user_id: contact_id
        }
    };

    await $http.get('/api/eventos', parameters)
        .then((response) => {
            commit('setEventsDay', response.data.data);
        }).catch((error) => {
            console.log(error);
        });
}

export async function storeEvent({commit, state}, files) {
    return new Promise(async (resolve, reject) => {
        let form_data = new FormData();

        for (const property in state.event) {
            form_data.append(property, state.event[property]);
        }

        for (let i = 0; i < files.length; i++) {
            form_data.append('attachments_loaded[' + i + ']', files[i]);
        }

        await $http.post('/api/eventos', form_data).then((response) => {
            commit('setModalShow', false);
            Notification.success({
                title: 'Muy bien!',
                message: 'Evento agendado correctamente',
                type: 'success',
                duration: 3000,
                customClass: 'notification-box',
            });
            resolve();
        }).catch((error) => {
            Notification.error({
                title: 'Error!',
                message: 'Error al agendar el evento',
                type: 'error',
                duration: 3000,
                customClass: 'notification-box',
            });
            reject();
        });
    });
}

export async function deleteEvent({commit, state}) {
    return new Promise(async (resolve, reject) => {

        const parameters = {
            params: {
                edit_mode: state.edit_mode
            }
        };

        await $http.delete('/api/eventos/' + state.event.id, parameters)
            .then((response) => {
                commit('setModalShow', false);
                Notification.success({
                    title: 'Muy bien!',
                    message: 'Evento eliminado correctamente',
                    type: 'success',
                    duration: 3000,
                    customClass: 'notification-box',
                });
                resolve();
            }).catch((error) => {
                Notification.error({
                    title: 'Error!',
                    message: 'Error al eliminar el evento',
                    type: 'error',
                    duration: 3000,
                    customClass: 'notification-box',
                });
                reject();
            });
    });
}

export async function closeEvent({commit, state}) {
    return new Promise(async (resolve, reject) => {
        await $http.post('/api/eventos/atendido/' + state.event.id)
            .then((response) => {
                commit('setModalShow', false);
                Notification.success({
                    title: 'Muy bien!',
                    message: 'Evento marcado como atendido correctamente',
                    type: 'success',
                    duration: 3000,
                    customClass: 'notification-box',
                });
                resolve();
            }).catch((error) => {
                Notification.error({
                    title: 'Error!',
                    message: 'Error al marcar el evento como atendido',
                    type: 'error',
                    duration: 3000,
                    customClass: 'notification-box',
                });
                reject();
            });
    });
}

export async function updateEvent({commit, state}, files) {
    return new Promise(async (resolve, reject) => {

        let form_data = new FormData();

        for (const property in state.event) {
            if (property !== 'attachments_deleted' && property !== 'attachments_loaded') {
                form_data.append(property, state.event[property]);
            }
        }

        for (let i = 0; i < files.length; i++) {
            form_data.append('attachments_loaded[' + i + ']', files[i]);
        }

        for (let i = 0; i < state.event.attachments_deleted.length; i++) {
            form_data.append('attachments_deleted[' + i + ']', state.event.attachments_deleted[i].id);
        }

        form_data.append('edit_mode', state.edit_mode);

        commit('setEventEditMode', state.edit_mode);

        await $http.post('/api/eventos/' + state.event.id, form_data)
            .then((response) => {
                commit('setModalShow', false);
                Notification.success({
                    title: 'Muy bien!',
                    message: 'Evento actualizado correctamente',
                    type: 'success',
                    duration: 3000,
                    customClass: 'notification-box',
                });
                resolve();
            }).catch((error) => {
                Notification.error({
                    title: 'Error!',
                    message: 'Error al actualizar el evento',
                    type: 'error',
                    duration: 3000,
                    customClass: 'notification-box',
                });
                reject();
            });
    });
}

export async function deleteAttachment({commit, state}, attachment) {
    await MessageBox.confirm('¿Está seguro de eliminar el adjunto?', 'Eliminar adjunto', {
        confirmButtonText: 'Aceptar',
        cancelButtonText: 'Cancelar',
        type: 'warning',
        customClass: 'notification-danger'
    }).then(async (result) => {
        commit('addAttachmentDeleteEvent', attachment);
        commit('deleteAttachmentEvent', attachment);
    }).catch((e) => {
        console.error(e);
    });
}

export async function downloadAttachment({}, attachment) {
    await $http({
        url: '/api/descargar-adjunto-eventos/' + attachment.id,
        method: 'GET',
        responseType: 'blob', // important
    }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', attachment.original_name);
        document.body.appendChild(link);
        link.click();
    }).catch((error) => {
        Notification.error({
            title: 'Error!',
            message: error.message,
            type: 'error',
            duration: 3000,
            customClass: 'notification-box',
        });

    });
}

export async function getCoordinates({commit}) {
    navigator.geolocation.getCurrentPosition(
        position => {
            let latitude = position.coords.latitude;
            let longitude = position.coords.longitude;

            commit('setCoordinatesUser', latitude + ',' + longitude);
            commit('setCoordinates', latitude + ',' + longitude);
        },
        error => {
            console.log(error.message);
        },
    );
}



// WEBPACK FOOTER //
// ./src/modules/schedule/actions.js